import React from "react";
import moment from "moment";

//import Subheader from "../Board/Subheader";
import BarChart from "../BarChart";
import RegressionInfo from "./RegressionInfo";
import { getDayName } from "../../tools";
import { useTranslation } from "react-i18next";
import EmptyBoard from "./EmptyBoard";
import PieChart from "../PieChart";

function WeekBoard(props) {
  const { t } = useTranslation();
  const {
    data,
    quantitativeLabelsChecked,
    table,
    selectedLabels,
    labelOpacity,
    //setLabelOpacity,
    thumbnail,
    error,
    showValues,
    verticalBars,
    pieChart,
    sortDec,
  } = props;

  const categoricalRegression = window.categoricalRegression;

  const days = new Array(7)
    .fill(1)
    .map((_, index) => getDayName(moment().day(index + 1)));
  const analyses = quantitativeLabelsChecked.map((label) => {
    const labelCategories = days.map((day, index) => {
      const values = data
        .filter((beep) => moment(beep.time).format("dddd") === day)
        .flatMap((beep) =>
          beep.table
            .filter((row) => row.id === label.id)
            .map((value) => value.score)
        );
      let bits = new Array(days.length).fill(0);
      if (values.length > 0) {
        bits[index] = 1;
      }
      const categoryIndex = values.length > 0 ? values.flatMap(() => bits) : []; // each value is equal to categorical bits

      return {
        day: day,
        values: values,
        categoryIndex: categoryIndex,
      };
    });
    //console.log(labelCategories);
    const valuesForCatReg = labelCategories.flatMap(({ values }) => values);
    //console.log(valuesForCatReg);
    const indicesForCatReg = labelCategories.flatMap(
      ({ categoryIndex }) => categoryIndex
    );

    //console.log(indicesForCatReg);
    return {
      ...categoricalRegression(valuesForCatReg, indicesForCatReg),
      id: label.id,
      label: label.label,
      question: label.question,
    };
  });
  //console.log(analyses);
  const barchart = days.map((day, index) => {
    let dataObj = { name: day };
    analyses.forEach((analyse) => {
      let value = analyse.M[index + 1];
      if (value > 100) value = 100;
      if (value < 0) value = 0;
      value = Math.round((value + Number.EPSILON) * 100) / 100;

      const errorMin = !isNaN(analyse.DELTAPLOW[index + 1])
        ? analyse.DELTAPLOW[index + 1] * 100
        : 0;
      const errorMax = !isNaN(analyse.DELTAPUP[index + 1])
        ? analyse.DELTAPUP[index + 1] * 100
        : 0;
      const error = [errorMin, errorMax];

      const numberOfMeasurements = analyse.NM[index + 1];

      if (!isNaN(value)) {
        dataObj[`${analyse.id}`] = value;
        dataObj[`${analyse.id}$label`] = analyse.label;
        dataObj[`${analyse.id}$error`] = error;
        dataObj[`${analyse.id}$numberOfMeasurements`] = numberOfMeasurements;
      }
    });
    return dataObj;
  });

  //console.log(barchart);

  return (
    <React.Fragment>
      {pieChart ? (
        <PieChart
          data={barchart}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          height={!thumbnail ? 250 : 80}
          thumbnail={thumbnail}
          showValues={showValues}
          sortDec={sortDec}
        />
      ) : (
        <BarChart
          data={barchart}
          quantitativeLabelsChecked={quantitativeLabelsChecked}
          opacity={labelOpacity}
          height={!thumbnail ? 250 : 80}
          thumbnail={thumbnail}
          error={error}
          showValues={showValues}
          verticalBars={verticalBars}
          sortDec={sortDec}
        />
      )}
      {!thumbnail ? (
        <RegressionInfo
          category={t("moodboards.weekday")}
          analyses={analyses}
        />
      ) : null}
    </React.Fragment>
  );
}

export default WeekBoard;
